import { ReactNode } from 'react'

export default function Alert({ tone, children }: { tone: 'error' | 'info'; children: ReactNode }) {
  return (
    <div role={tone === 'error' ? 'alert' : 'status'} className={`ho-alert ho-alert-${tone}`}>
      {children}
    </div>
  )
}
